interface IMeState {
  id?: number;
  name?: string;
  userTitle?: string;
  isBeta?: boolean;
  isReferenceRequired: boolean;
  permissions?: string[];
  demo: boolean;
}

interface IMeMutation {
  setId: (state: IMeState, id: number) => void;
  setName: (state: IMeState, text: string) => void;
  setUserTitle: (state: IMeState, text: string) => void;
  setIsBeta: (state: IMeState, isBeta: boolean) => void;
  setIsReferenceRequired: (state: IMeState, isReferenceRequired: boolean) => void;
  setPermissions: (state: IMeState, array: string[]) => void;
  setDemo: (state: IMeState, demo: boolean) => void;
}

export const state: IMeState = {
  name: undefined,
  userTitle: undefined,
  isBeta: false,
  isReferenceRequired: false,
  permissions: [],
  demo: false
}

export const mutations: IMeMutation = {
  setId (state: IMeState, id: number): void {
    state.id = id
  },
  setName (state: IMeState, text: string): void {
    state.name = text
  },
  setUserTitle (state: IMeState, text: string): void {
    state.userTitle = text
  },
  setPermissions (state: IMeState, array: string[]): void {
    state.permissions = array
  },
  setIsBeta (state: IMeState, isBeta: boolean): void {
    state.isBeta = isBeta
  },
  setIsReferenceRequired (state: IMeState, isReferenceRequired: boolean): void {
    state.isReferenceRequired = isReferenceRequired
  },
  setDemo (state: IMeState, demo: boolean): void {
    state.demo = demo
  }
}
